import { HttpParams } from "@angular/common/http";

export const constructApiVersionQueryParams = (inputParams: HttpParams | undefined): HttpParams => {
  if (inputParams && inputParams.keys().length > 0) {
    return inputParams;
  }

  return new HttpParams();
};
